// src/legal/ImprintPage.jsx
import React from "react";
import { ReactComponent as ImpressumIcon } from "../icons/Impressum_icon.svg";


export function ImprintPage() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <ImpressumIcon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>Impressum</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>Angaben gemäß § 5 DDG</h2>
      <p style={p}>mts individual carstyling GmbH</p>
      <p style={p}>Rilkestrasse 32b</p>
      <p style={p}>37120 Bovenden</p>
      <p style={p}>Deutschland</p>

      <div style={{ height: 6 }} />

      <p style={p}>
        Telefon: 0551 291 250 30
        <br />
        E-Mail: info@legendstools.de, support@mts-carstyling.de
        <br />
        Web: https://legendstools.de
      </p>

      {/* Vertretungsberechtigter */}
      <h2 style={h2}>Vertreten durch die Geschäftsführung:</h2>
      <p style={p}>Marcus Brocks</p>

      {/* Register */}
      <h2 style={h2}>Registereintrag</h2>
      <p style={p}>Registergericht: Amtsgericht Göttingen</p>
      <p style={p}>Handelsregister-Nummer: HRB 205531</p>

      {/* USt-ID */}
      <h2 style={h2}>Umsatzsteuer-ID</h2>
      <p style={p}>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
      </p>
      <p style={p}>DE178253901</p>

      {/* Verantwortlich für Inhalte */}
      <h2 style={h2}>Verantwortlich für den Inhalt</h2>
      <p style={p}>
        Verantwortlich im Sinne des § 18 Abs. 2 MStV:
        <br />
        Marcus Brocks
        <br />
        Rilkestrasse 32b
        <br />
        37120 Bovenden
      </p>

      {/* Haftungsausschluss kurz (du kannst später ausbauen oder aus Muster übernehmen) */}
      <h2 style={h2}>Verbraucherstreitbeilegung</h2>
      <p style={p}>
      Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.
      <br />
      Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., Straßburger Straße 8, 77694 Kehl am Rhein
      <br />
      [https://www.verbraucher-schlichter.de].
      </p>

      <h2 style={h2}>Zentrale Kontaktstelle nach dem Digital Services Act - DSA (Verordnung (EU) 2022/265)</h2>
      <p style={p}>
      Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
      <br />
      E-Mail: dsa@mts-carstyling.de Tel.: 0551 291 250 30
      <br />
      Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch.
      </p>

      <h2 style={h2}>Rechtlicher Hinweis</h2>
      <p style={p}>
      Texte, Bilder, Grafiken, Animationen, Video- und Audiodateien sowie alle weiteren Inhalte auf dieser Webseite unterliegen den gesetzlichen Bestimmungen des Urheberrechts und ggf. weiteren Rechten des geistigen Eigentums. Der geschützte Inhalt dieser Webseite darf ohne Einwilligung des Rechtsinhabers nicht vervielfältigt, verbreitet, wiedergegeben, öffentlich zugänglich gemacht oder sonst verwertet werden.
      <br />
      Änderungen von Angeboten, Design, Lieferumfang und Abweichungen sowie Irrtümer bleiben vorbehalten.
      <br />
      mts individual® ist eingetragenes Warenzeichen der MTS Individual Car Styling GmbH.
      
      </p>

      <div style={small}>
      Copyright © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH. 
      </div>
    </div>
  );
}


